import React from 'react'
import NumbersCommonForm from './NumbersCommonForm'
import NumbersUsagePlanSelectStep from 'features/Numbers/NumbersUsagePlanSelectStep'
import NumbersProductSelectStep from 'features/Numbers/NumbersProductSelectStep'
import NumbersSelectNewNumberStep from 'features/Numbers/NumbersSelectNewNumberStep'
import NumbersTransferExistingStep from 'features/Numbers/NumbersTransferExistingStep'
import NumbersOtherSettingsStep from 'features/Numbers/NumbersOtherSettingsStep'
import NumbersSummaryStep from 'features/Numbers/NumbersSummaryStep'
import BillingAccountLinkStep from 'features/Billing/BillingAccountLinkStep'
import LoginOrRegister from 'features/Auth/LoginOrRegister'

export default class NumbersForm extends NumbersCommonForm {
  constructor(props) {
    super(props)

    const isLoggedIn = props.isLoggedIn

    this.state.steps = [
      ...(isLoggedIn
        ? []
        : [
            {
              wrapInForm: false,
              Component: () => <LoginOrRegister afterSubmit={this.submit} />,
              heading: 'Start Your 7-Day Free Trial!',
              subHeading: "First, you'll need your account, so sign up or sign In",
            },
          ]),
      {
        wrapInForm: true,
        Component: props => <NumbersUsagePlanSelectStep prev={props.onCancel} {...props} />,
      },
      {
        wrapInForm: true,
        Component: props => <NumbersProductSelectStep prev={this.prevStep} {...props} />,
        heading: 'Now we add a Virtual Number',
        subHeading: 'The number that your customers call you on',
      },
      {
        wrapInForm: true,
        Component: props =>
          props.formData.isNewNumber ? (
            <NumbersSelectNewNumberStep prev={this.prevStep} {...props} />
          ) : (
            <NumbersTransferExistingStep prev={this.prevStep} {...props} />
          ),
        heading: props =>
          props.formData.isNewNumber
            ? "Great let's get you a new Virtual Number"
            : "Great let's use your existing number",
        subHeading: props =>
          props.formData.isNewNumber
            ? 'Now to go Premium or Standard...'
            : 'Is your number Active or Inactive?',
      },
      {
        wrapInForm: true,
        Component: props => <NumbersOtherSettingsStep prev={this.prevStep} {...props} />,
        heading: 'Tell us here where you want your calls to go',
        subHeading: "It can be the phone you're already using",
      },
      {
        wrapInForm: true,
        Component: props => <BillingAccountLinkStep prev={this.prevStep} {...props} />,
        heading: 'Need a separate account? We can do that',
        subHeading: "Let's get this Classic Solution working for you",
      },
      {
        wrapInForm: true,
        Component: props => <NumbersSummaryStep prev={this.prevStep} {...props} />,
        heading: "And we're done. Great Huh!",
        subHeading: "Now that's a Simply Awesome Classic Solution",
      },
    ]

    this.submit = this.submit.bind(this)
  }

  componentWillMount() {
    const {
      change,
      productId,
      productName,
      formData,
      numberType,
      getAvailable1300Numbers,
      getAvailable1800Numbers,
    } = this.props
    if (numberType === '1300') {
      getAvailable1300Numbers()
    } else {
      getAvailable1800Numbers()
    }
    if (formData.productId !== productId) {
      change('productId', productId)
      change('productName', productName)
      change('step', 0)
    }
    change('lastEdited', new Date())
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersForm/NumbersForm.jsx